exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mError{color:red}.m-title,.m-title.active{text-transform:capitalize!important;font-size:10px!important}", ""]);

// exports
